'use client';
import Tags from "@/components/common/Tags";
import ImageGallery from "@/components/common/image-gallery";
import { PostContentFallback, useLoadPostBySlug } from "@/components/common/posts/posts.provider";
import { SimilarPosts } from "@/components/common/posts/similar-posts";
import SectionPage from "@/components/common/section-page";

export default function PostPage() {
    const {currentPost, postsBasePath} = useLoadPostBySlug("2026/09/africa-space-expo");

    return (
        <PostContentFallback>
            <article>
                <div style={{ backgroundImage: `url(${currentPost?.image})`, backgroundPosition: "center 22%" }} className={"h-[400px] w-full bg-cover relative"}>
                    <div className={"bg-bleu-marine h-[100px] w-full flex items-center justify-start absolute bottom-0"}>
                        <SectionPage sectionType={"2xl"}>
                            <h1 className={"text-white text-4xl font-exo"}>{currentPost?.title}</h1>
                        </SectionPage>
                    </div>
                </div>

                <SectionPage sectionType={"xl"} className={"my-12"}>
                    <div className="markdown-content text-gray-800">
                        <p className="my-4 text-normal leading-relaxed">
                            Du 24 au 26 septembre 2026, le Parc des Expositions d’Abidjan accueille l’Africa Space Expo, le plus grand événement continental dédié au business spatial africain.
                        </p>

                        <p className="my-4 text-normal leading-relaxed">
                            Couplé au Forum des Radiocommunications de l’AIGF, ce rendez-vous réunit institutions, entreprises et experts autour du thème « Le spatial africain en action : structurer, décider et déployer pour le développement socio-économique durable du continent ». L’Angola et les États-Unis sont les pays invités d’honneur de cette édition.
                        </p>

                        <p className="my-4 text-normal leading-relaxed">
                            Placé sous le haut patronage de l’Union Africaine, de l’Agence Spatiale de Côte d’Ivoire (ASCI) et de la Fondation Eburnie Space, l’événement a été marqué par la prise de parole de Madame le Directeur Général de Côte d’Ivoire Tourisme.
                        </p>

                        <p className="my-4 text-normal leading-relaxed">
                            Côte d’Ivoire Tourisme est fier de s’associer à cette vitrine internationale de l’innovation spatiale en terre ivoirienne. Sur son espace, le stand a mis en lumière le lien entre terroir et innovation, autour du cacao et du chocolat ivoiriens, et a accueilli un public nombreux, notamment des jeunes et des scolaires venus découvrir la destination.
                        </p>

                        <div className={'my-8'}>
                            <ImageGallery images={
                                Array.from({ length: 10 }).map((_, index) => ({
                                    src: `/images${postsBasePath}/${String(currentPost?.slug)}/${index + 1}.jpg`,
                                    alt: `image${index + 1}`,
                                    width: 700,
                                    height: 700,
                                }))
                            } aspectRatio={"video"} />
                        </div>

                        <Tags tags={['AfricaSpaceExpo', 'ASPEX', 'Abidjan', 'Spatial', 'Innovation', 'CôtedIvoire', 'CôtedIvoireTourisme', 'Cacao']} />
                    </div>

                    <SimilarPosts currentSlug={String(currentPost?.slug)} />
                </SectionPage>
            </article>
        </PostContentFallback>
    );
}
